import { useCallback, useEffect, useState } from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import {
  readInventoryMovementMode,
  writeInventoryMovementMode,
  type InventoryMovementMode,
} from '../lib/inventoryMovementModeStorage';

export type { InventoryMovementMode };

/** Persisted Sales / Consumed toggle for the control-centre inventory widget. */
export function useInventoryMovementMode() {
  const { selectedBusiness } = useBusiness();
  const businessId = selectedBusiness?.id;

  const [mode, setModeState] = useState<InventoryMovementMode>(() =>
    readInventoryMovementMode(businessId)
  );

  useEffect(() => {
    setModeState(readInventoryMovementMode(businessId));
  }, [businessId]);

  const setMode = useCallback(
    (next: InventoryMovementMode) => {
      setModeState(next);
      writeInventoryMovementMode(next, businessId);
    },
    [businessId]
  );

  return { mode, setMode };
}
